import { ResUserLoginRedirectEnum } from "./login";

export class User {
  id!: string;
  fullName!: string;
  email!: string;
  token!: string;
  role!: string;
  permissions!: string[];
  profilePicture!: string;
  profilePic!: string;
  owneRestaurant!: UserRest[]
  loginRedirectEnum!: ResUserLoginRedirectEnum
  language!: string
}
export interface UserRest {
  id: number
  name: string
  addtill: boolean
  attendancefeature: boolean
  canPrintLastshift: boolean
  requiredaction: Requiredaction
  lastClockIn: string
}

export enum Requiredaction {
  ClockIn = 'ClockIn',
  ClockOut = 'ClockOut',
  NoAction = 'NoAction'
}
